module.exports = __webpack_public_path__ + "img/submit.e4b53b57.svg";